import { render, staticRenderFns } from "./payroll-slip.vue?vue&type=template&id=41055504&scoped=true&"
import script from "./payroll-slip.vue?vue&type=script&lang=js&"
export * from "./payroll-slip.vue?vue&type=script&lang=js&"
import style0 from "./payroll-slip.vue?vue&type=style&index=0&id=41055504&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41055504",
  null
  
)

export default component.exports